import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';
import AnimateIn from '@/components/base/AnimateIn';

export default function FeaturedArticles() {
  const featuredArticles = articles.filter((a) => a.featured).slice(0, 3);

  return (
    <section className="w-full px-4 md:px-6 py-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              热门推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              编辑精选的优质内容，不容错过
            </p>
          </div>
          <Link
            to="/category/guide"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredArticles.map((article, idx) => (
            <AnimateIn key={article.id} delay={idx * 100}>
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={`${article.title} - 91叔叔`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs text-foreground-400">{article.date}</span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
              </div>
            </Link>
            </AnimateIn>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/guide"
            className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}